import { img } from '@/assets';
import PropTypes from 'prop-types';
import { Style } from '@/components/style';
import { useEffect, useState } from 'react';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import { setWelcomeLocale } from '@/actions/customizeWelcome/customizeWelcomeAction';
import { setUberDirectDeliveryType } from '@/actions/uberDirect/uberDirectAction';
import DeliveryType from '@/constants/DeliveryType';
import { setMemberLangs } from '@/actions/member/memberAction';
import Member from '@/components/member/member';
import LocaleDropDownMenu from './components/localeDropDownMenu';
import ServeTypeLayout from './components/serveTypeLayout';
import Privacy from './components/privacy';
import WelcomeCTA from './components/welcomeCTA';
import SearchBtnWelcome from './components/searchBtnWelcome';
import './customizeWelcome.scss';
import WelcomeHeader from '@/components/customizeWelcome/components/welcomeHeader';

const { backgroundColor } = new Style().getUiConfig();

function CustomizeWelcome({ locale, setLocale, isTest }) {
  const dispatch = useDispatch();
  const webStoreVoResponse = useSelector(
    (state: RootStateOrAny) => state.welcomeReducer.webStoreVoResponse
  );
  const showMemberDropDown = useSelector<RootStateOrAny, any>(
    (state) => state.memberReducer.showMemberDropDown
  );
  const [webStoreVo, setWebStoreVo] = useState<any>({});
  const [orderVo, setOrderVo] = useState<any>({});

  useEffect(() => {
    dispatch(setWelcomeLocale(locale));
  }, [locale]);

  const getDeliveryType = (type) => {
    if (type === DeliveryType.UBER_DIRECT) {
      dispatch(setUberDirectDeliveryType(true));
      return;
    }
    dispatch(setUberDirectDeliveryType(false));
  };

  useEffect(() => {
    if (webStoreVoResponse?.data?.webStoreVo)
      setWebStoreVo(webStoreVoResponse.data.webStoreVo);

    if (webStoreVoResponse?.data?.orderVo)
      setOrderVo(webStoreVoResponse.data.orderVo);

    if (webStoreVoResponse.data.webStoreVo) {
      getDeliveryType(webStoreVoResponse.data.webStoreVo.deliveryPlatform);
    }

    if (webStoreVoResponse?.data?.webStoreVo?.langs) {
      dispatch(setMemberLangs(webStoreVoResponse.data.webStoreVo.langs));
    }
  }, [webStoreVoResponse]);

  return (
    <div className="container-welcome">
      {/* 會員功能 */}
      <Member
        storeUuid={webStoreVo.uuid}
        storeDisplay={webStoreVo.displayName}
      />
      <main>
        {webStoreVo && (
          <div className="container ps-4 pe-4 mb-4">
            {showMemberDropDown && <div className="background" />}
            <WelcomeHeader webStoreVo={webStoreVo} />
            {/* 商店 Logo */}
            <div
              className="d-flex mx-auto mb-3"
              style={{
                width: 'calc(345px*0.7)',
                height: 'calc(210px*0.7)',
                backgroundColor: webStoreVo?.uiConfig
                  ? JSON.parse(webStoreVo.uiConfig)?.maColorPrimary
                  : backgroundColor,
                borderRadius: '5px',
                marginTop: '50px',
              }}
            >
              <img
                style={{
                  maxWidth: '100%',
                  maxHeight: '100%',
                }}
                className="mx-auto align-items-center align-self-center"
                src={
                  webStoreVo.brandImageUrl
                    ? webStoreVo.brandImageUrl
                    : img.icon.maIcon
                }
                alt=""
              />
            </div>

            {/* 語系下拉選單 */}
            <LocaleDropDownMenu
              locale={locale}
              setLocale={setLocale}
              webStoreVo={webStoreVo}
            />

            {/* 服務類型row & 訂單資料輸入 & 文字提示區 & 既有訂單 */}
            <ServeTypeLayout webStoreVo={webStoreVo} orderVo={orderVo} />

            {/* CTA */}
            <WelcomeCTA webStoreVo={webStoreVo} orderVo={orderVo} />

            {/* 訂單查詢 點數查詢 */}
            <SearchBtnWelcome webStoreVo={webStoreVo} />
          </div>
        )}
      </main>

      <footer>
        {/* 下方店家資訊 & 隱私權政策 / 電小二官網 */}
        {webStoreVo?.webUiConfig?.showStoreInfo && (
          <div>
            {/* 下方店家資訊區塊 */}
            {/* <BottomStoreInfo webStoreVo={webStoreVo} /> */}
            {/* 隱私權政策 / 電小二官網 */}
            <Privacy webStoreVo={webStoreVo} />
          </div>
        )}
      </footer>
    </div>
  );
}

CustomizeWelcome.defaultProps = {
  isTest: false,
};
CustomizeWelcome.propTypes = {
  locale: PropTypes.string.isRequired,
  setLocale: PropTypes.func.isRequired,
  isTest: PropTypes.bool,
};
export default CustomizeWelcome;
